import src from "IMAGE";
export default { src, width: 496, height: 497, blurWidth: 0, blurHeight: 0};
